import axios from "axios"
import { del, get, post, postFile, put, postData, typeResource,postLoginToken } from "./api_helper"
import * as url from "./url_helper"
import { ToastHelper } from './alerts/alertHelper';
// Gets the logged in user data from local session
const getLoggedInUser = () => {
    const user = localStorage.getItem("authUser")
    if (user) return JSON.parse(user)
    return null
}

const getAuthUser = () => {
    const user = localStorage.getItem("authUser")
    if (user) return JSON.parse(user).user
    return null
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null
}


//Auth
export const resetPassword = (data) => post(url.RESET_PASSWORD, data)
export const logOut = () => post(url.LOG_OUT)
export const resetConfirm = (data) => post(url.RESET_CONFIRM, data)
export const validaToken = (data) => post(url.VALIDA_TOKEN, data)
//catalogs
export const superDepartmentsResource = (type, data = {}, id = null) => typeResource(url.SUPER_DEPARTMENTS_RESOURCE, type, data, id)
//SAles
export const salesResource = (type, data = {}, id = null) => typeResource(url.SALES_RESOURCE, type, data, id)
//Home
export const getDataHome = (data) => get(url.GET_DATA_HOME, data)

//Users
//Clients
// Administrador
//sellers
export const sellersResource = (type, data = {}, id = null) => typeResource(url.SELLERS_RESOURCE, type, data, id)
//CATEGORIES
export const categoriesResource = (type, data = {}, id = null) => typeResource(url.CATEGORIES_RESOURCE, type, data, id)
//DEPARTMENTS
export const departmentsResource = (type, data = {}, id = null) => typeResource(url.DEPARTMENTS_RESOURCE, type, data, id)
//products
export const productsResource = (type, data = {}, id = null) => typeResource(url.PRODUCTS_RESOURCE, type, data, id)
export const clientsResource = (type, data = {}, id = null) => typeResource(url.CLIENTS_RESOURCE, type, data, id)

export {
    getLoggedInUser,
    isUserAuthenticated,
    getAuthUser
}
